/**
* 左边菜单
*/ 
<template>
  <el-menu
    default-active="2"
    :collapse="collapsed"
    collapse-transition
    router
    :default-active="$route.path"
    unique-opened
    class="el-menu-vertical-demo"
    background-color="#334157"
    text-color="#fff"
    active-text-color="#ffd04b"
  >
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="" />
    </div>
    <el-submenu
      v-for="menu in allmenu"
      :key="menu.menuid"
      :index="menu.menuname"
    >
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{ menu.menuname }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item
          v-for="chmenu in menu.menus"
          :index="'/' + chmenu.url"
          :key="chmenu.menuid"
        >
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{ chmenu.menuname }}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from "../api/userMG";
export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
      allmenu: [],
    };
  },

  created() {
    // 总管理
    if (this.$store.state.usuerdata.role == "128") {
      let admin = [
        {
          menuid: 1,
          icon: "",
          menuname: "个人信息",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: "",
              menuname: "详情",
              hasThird: "N",
              url: "my/infos",
              menus: null,
            },
          ],
        },
        {
          menuid: 1,
          icon: "",
          menuname: "学校管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: "",
              menuname: "列表详情",
              hasThird: "N",
              url: "school/schoollits",
              menus: null,
            },
            {
              menuid: 3,
              icon: "",
              menuname: "实验配置",
              hasThird: "N",
              url: "school/shiyanguanli",
              menus: null,
            },
          ],
        },
      ];
      this.allmenu = admin;
    }
    // 校管
    if (this.$store.state.usuerdata.role == "64") {
      let adminsc = [
        {
          menuid: 1,
          icon: "",
          menuname: "个人信息",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: "",
              menuname: "详情",
              hasThird: "N",
              url: "my/infos",
              menus: null,
            },
          ],
        },
        {
          menuid: 1,
          icon: "",
          menuname: "班级管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: "",
              menuname: "班级详情",
              hasThird: "N",
              url: "xiaoguanclassllits",
              menus: null,
            },
          ],
        },
        {
          menuid: 1,
          icon: "",
          menuname: "账号管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: "",
              menuname: "班级账号",
              hasThird: "N",
              url: "xiaoguanuser",
              menus: null,
            },
            {
              menuid: 2,
              icon: "",
              menuname: "老师账号",
              hasThird: "N",
              url: "xiaoguanteacherUser",
              menus: null,
            },
          ],
        },
      ];
      this.allmenu = adminsc;
    }
    // 老师
    if (this.$store.state.usuerdata.role == "8") {
      let teacher = [
        {
          menuid: 1,
          icon: "",
          menuname: "个人信息",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: "",
              menuname: "详情",
              hasThird: "N",
              url: "my/infos",
              menus: null,
            },
          ],
        },
        {
          menuid: 1,
          icon: "",
          menuname: "班级管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: "",
              menuname: "班级详情",
              hasThird: "N",
              url: "class",
              menus: null,
            },
          ],
        },
        {
          menuid: 1,
          icon: "",
          menuname: "账号管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: "",
              menuname: "账号详情",
              hasThird: "N",
              url: "user",
              menus: null,
            },
          ],
        },
        {
          menuid: 1,
          icon: "",
          menuname: "班级实验结果",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: "",
              menuname: "详情",
              hasThird: "N",
              url: "shiyan/shiyanteacher",
              menus: null,
            },
          ],
        },
        {
          menuid: 1,
          icon: "",
          menuname: "个人实验结果",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: "",
              menuname: "详情",
              hasThird: "N",
              url: "shiyan/shiyan",
              menus: null,
            },
          ],
        },
      ];
      this.allmenu = teacher;
    }
    //学生
    if (this.$store.state.usuerdata.role == "1") {
      let student = [
        {
          menuid: 1,
          icon: "",
          menuname: "个人信息",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: "",
              menuname: "详情",
              hasThird: "N",
              url: "my/infos",
              menus: null,
            },
          ],
        },
        {
          menuid: 1,
          icon: "",
          menuname: "实验结果",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: "",
              menuname: "详情",
              hasThird: "N",
              url: "shiyan/shiyan",
              menus: null,
            },
          ],
        },
      ];
      this.allmenu = student;
    }

    // 监听
    this.$root.Bus.$on("toggle", (value) => {
      this.collapsed = !value;
    });
  },
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue